module.exports = __webpack_public_path__ + "img/3_6_1.f229982e.jpg";